import { Rout_create } from './Rout.create'
import { Rout_to } from './Rout'

export type TPage =
    | 'personalise'
    | 'language'
    | 'security'
    | 'about'
    | 'troubleshooting'
    | 'info'
    | 'security-success'
    | 'device'
    | 'build-info'
    | 'user-profile'

export interface Rout_SettingsRoutesArgs {
    Sett_App: React.FunctionComponent<unknown>
}

export const Rout_SettingsRoutes = (args: Rout_SettingsRoutesArgs) => [
    Rout_create('/settings/:page', args.Sett_App),
    Rout_create('/settings', args.Sett_App),
]

export function Rout_getSettingsPage(route: { path: string }): 'settings' | 'subpage' {
    if (route.path === '/settings/:page') return 'subpage'
    return 'settings'
}

export function Rout_toSettings(page?: TPage) {
    if (page != null) {
        Rout_to(`/settings/${page}`)
    } else {
        Rout_to(`/settings`)
    }
}
